import SectionHeader from "../SectionHeader/SectionHeader";
import styles from "./Contact.module.css";
import {
  contactInfo,
  socialLinks,
  useContactController,
} from "./Contact.controller";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Contact = () => {
  const { handleSubmit } = useContactController();

  return (
    <section className={styles.contactSection} id="contact">
      <div className={styles.contactContent}>
        <div className={styles.header}>
          <SectionHeader
            eyebrow="Contact us"
            title="Ready to build something remarkable?"
            description="Tell us about your product or idea. We will craft a tailored plan and show you how quickly we can help you launch."
          />
          <div className={styles.contactHighlights}>
            <div className={styles.infoCard}>
              <div className={styles.infoTitle}>Email us at:</div>
              <a
                className={styles.infoValue}
                href={`mailto:${contactInfo.email}`}
              >
                {contactInfo.email}
              </a>
            </div>
            <div className={styles.infoCard}>
              <div className={styles.infoTitle}>Call/Chat us on/at:</div>
              <div className={styles.infoValueRow}>
                <a
                  className={styles.infoValue}
                  href={`tel:${contactInfo.phone}`}
                >
                  {contactInfo.phone}
                </a>
                <a
                  className={`${styles.socialIcon} ${styles.whatsappIcon}`}
                  href={`https://wa.me/${contactInfo.phone}`}
                  aria-label="WhatsApp"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
              </div>
            </div>
            <div className={styles.infoCard}>
              <div className={styles.infoTitle}>Our social media</div>
              <div className={styles.socialRow}>
                {socialLinks.map((item) => {
                  const icon =
                    item.icon === "facebook"
                      ? faFacebookF
                      : item.icon === "instagram"
                      ? faInstagram
                      : faTiktok;

                  return (
                    <a
                      key={item.label}
                      className={styles.socialIcon}
                      href={item.href}
                      aria-label={item.label}
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={icon} />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" placeholder="Your name" required />
          </label>
          <label>
            Company
            <input type="text" placeholder="Organization" />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@company.com" required />
          </label>
          <label>
            What can we help you build?
            <textarea
              rows={4}
              placeholder="Website, mobile app, platform, integrations..."
            />
          </label>
          <button
            type="submit"
            className={`${styles.btn} ${styles.primary} ${styles.full}`}
          >
            Send message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
